import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppHeader } from '../App.js';
import { api, ApiError } from '../utils/api.js';
export function ProjectPicker() {
    const { groupId } = useParams();
    const [projects, setProjects] = useState(null);
    const [error, setError] = useState(null);
    const [creating, setCreating] = useState(false);
    const [newName, setNewName] = useState('');
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();
    async function reload() {
        if (!groupId)
            return;
        try {
            const r = await api.get(`/orgs/${groupId}/projects`);
            setProjects(r.projects);
            setError(null);
        }
        catch (e) {
            setError(e.message);
        }
    }
    useEffect(() => { void reload(); }, [groupId]);
    function openProject(p) {
        nav(`/p/${p.projectId}`);
    }
    async function createProject() {
        if (!groupId || !newName.trim())
            return;
        setBusy(true);
        setError(null);
        try {
            const r = await api.post(`/projects`, {
                groupId,
                name: newName.trim(),
            });
            nav(`/p/${r.projectId}`);
        }
        catch (e) {
            if (e instanceof ApiError)
                setError(e.message);
            else
                setError(e.message);
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsxs("div", { className: "app-shell", children: [_jsx(AppHeader, {}), _jsxs("div", { style: { padding: 30, maxWidth: 720, width: '100%', margin: '0 auto' }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', marginBottom: 16 }, children: [_jsx("button", { className: "ghost", onClick: () => nav('/orgs'), style: { marginRight: 12 }, children: "\u2190 Organisations" }), _jsx("h2", { style: { margin: 0 }, children: "Projects" }), _jsx("div", { style: { flex: 1 } }), _jsx("button", { onClick: () => setCreating(true), children: "+ New project" })] }), error && _jsx("div", { className: "error", children: error }), !projects && !error && _jsx("div", { className: "empty", children: "Loading..." }), projects && projects.length === 0 && (_jsx("div", { className: "empty", children: "No projects yet. Click \"+ New project\" to create one." })), projects && projects.length > 0 && (_jsx("ul", { className: "list", children: projects.map((p) => (_jsxs("li", { onClick: () => openProject(p), children: [_jsxs("div", { children: [_jsx("div", { style: { fontWeight: 500 }, children: p.name }), _jsxs("div", { className: "meta", children: ["created ", new Date(p.createdAt).toLocaleDateString()] })] }), _jsx("div", { className: "meta", children: "open" })] }, p.projectId))) })), creating && (_jsx("div", { className: "modal-bg", onClick: () => !busy && setCreating(false), children: _jsxs("div", { className: "modal", onClick: (e) => e.stopPropagation(), children: [_jsx("h3", { children: "New project" }), _jsx("p", { style: { color: 'var(--fg-muted)', marginTop: 0 }, children: "Provisions a fresh RainDB tenant under this organisation. This may take a few seconds." }), _jsx("label", { children: "Project name" }), _jsx("input", { value: newName, onChange: (e) => setNewName(e.target.value), autoFocus: true, disabled: busy }), error && _jsx("div", { className: "error", children: error }), _jsxs("div", { style: { display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }, children: [_jsx("button", { className: "ghost", onClick: () => setCreating(false), disabled: busy, children: "Cancel" }), _jsx("button", { onClick: () => void createProject(), disabled: busy || !newName.trim(), children: busy ? 'Creating...' : 'Create' })] })] }) }))] })] }));
}
